import http from '../http';

export default {
  createNote: ({ entityRef, orderRef, note }) =>
    http.post(`/connex/services/orders/${entityRef}/order-requests/${orderRef}/notes`, note),
  listNotes: ({ entityRef, orderRef }) =>
    http.get(`/connex/services/orders/${entityRef}/order-requests/${orderRef}/notes`),
  getEntity: entityRef => http.get(`/v2/admin/entities/${entityRef}`),
};
